interface IAccount {
  last_name: string
  first_name: string
  patronymic: string
}
export type Account = IAccount

// getAccountFio Получить ФИО из аккаунта.
export const getAccountFio = (account: Account): string => {
  const stringFio: string = (!!account && !!account.last_name ? account.last_name : '') + ' ' +
    (!!account && !!account.first_name ? account.first_name : '') + ' ' +
    (!!account && !!account.patronymic ? account.patronymic : '')

  return stringFio.replace(/\s+/g, ' ').trim()
}
